import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { ROLE_ROUTES } from "../config/roles";

const RequireAuthRedirect = () => {
  const { user, isAuthenticated, loading } = useAuth();

  // Wait until auth rehydration finishes
  if (loading) {
    return <div className="text-white text-center mt-10">Loading...</div>;
  }

  // ❗ FIX HERE
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const justLoggedIn = sessionStorage.getItem("justLoggedIn") === "true";
  if (justLoggedIn) {
    sessionStorage.removeItem("justLoggedIn");
  }

  const redirectPath = ROLE_ROUTES[user.role] || "/unauthorized";
  return <Navigate to={redirectPath} replace />;
};

export default RequireAuthRedirect;